 import { Component, OnChanges, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MatDialog, MatDialogRef } from '@angular/material/dialog'

import { BusStopService } from '../services/busstops/busstops.service';
import { DialogBusStop } from '../dialog/busstops/dialog.component.busstops';
import { IBusStop, IBusStopResponse } from './busstops.interfaces';

import { ListService } from '../list.service';
import { saveAs } from 'file-saver';

import { TokenStorageService } from '../services/auth-user-service/token-storage.service';

import { MatSidenav } from '@angular/material/sidenav';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mcrit-gestio-busstops',
  templateUrl: './busstops.component.html',
  styleUrls: [ './busstops.component.css' ],
  providers: [ BusStopService, ListService ]
})
export class BusStopsComponent implements OnInit, OnDestroy {
  public showAsyncProgress: boolean = false;
  public busStopData: IBusStopResponse;
  public userInfo: any = {};
  
  private activeFilters: any = {};
  private currentOrdering: any = {};
  private orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

  public firstRegisterShown: number = 0;
  public lastRegisterShown: number;
  public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
  private unsubscriber : Subject<void> = new Subject<void>();
  public showFilters: boolean = true;
  public export: boolean = false;
  public orderingParameters: any;

  private busStopModel: IBusStop = {
  'id': '',
  'name': '',
  'description': '',
  'lat': null,
  'long': null,
  'address': '',
  'city': '',
  'cp': '',
  'district': '',
  'direction': '',
  'type': '',
  'routes_served': null,
  'daily_passengers': null,
  'amenities': '',
  'installation': '',
  'last_inspection': '',
  'maintainded': '',
  'notes': ''
 };

  public error: string = '';
  public showDialog: boolean = false;
  public editBusStopData: IBusStop;

  public exportar(){this.export=true;this.requestRowsToParent();};

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  public addBusStop(): void {
    this.editBusStopData = Object.assign( {}, this.busStopModel, { plate: 'NEW' } );
    let dialogFactRef=this.dialog.open(DialogBusStop, {disableClose: true, width: '85vw', height: '85vh',  maxWidth: '95vw',  maxHeight: '95vh', data: {dades: this.editBusStopData, user: this.userInfo} })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editBusStopData = results;
      this.addOrUpdate();
    });
  }

  public editBusStop(busStop: IBusStop): void {
    this.editBusStopData = Object.assign( {}, this.busStopModel, busStop );
    let dialogFactRef=this.dialog.open(DialogBusStop, {width: '85vw', height: '85vh',  maxWidth: '95vw',  maxHeight: '95vh', data: {dades: this.editBusStopData, user: this.userInfo} })

    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editBusStopData = results;
      this.addOrUpdate();
    });
  }

  public addOrUpdate(): void {
    this.showAsyncProgress = true;

    if (this.editBusStopData.id === 'NEW') {
      this.busStopService.create(this.editBusStopData)
        .subscribe(newBusStop => {console.log("S'ha creat l'element");this.router.navigate(['busstop']);});
    } else {
      this.busStopService.update(<string> this.editBusStopData.id, this.editBusStopData)
        .subscribe(updatedBusStop => {console.log("S'han desat les dades");this.router.navigate(['busstop']);});
        //Actualitza la llista amb les modificacions
        let updateItem = this.busStopData.rows.find(item => item.id == this.editBusStopData.id);
        let index = this.busStopData.rows.indexOf(updateItem);
        this.busStopData.rows[index] = this.editBusStopData;
    }
  }

  public gotoPage(page: number): void {
    this.listBusStopService.currentPage = page;
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public toggleFiltersVisibility() {
     this.showFilters = !this.showFilters;
  }

  public computeActiveFilters($event){
    if(this.currentOrdering.length == 0)['nom'].map(item => this.currentOrdering[item] = this.orderingCycle[1]);
    this.activeFilters = $event;
    this.firstRegisterShown = 1 + this.listBusStopService.currentPage * this.listBusStopService.rowsPerPage;
    this.requestRowsToParent();
   }

  public cycleOrdering(key) {
    let i = this.orderingParameters[key]?this.orderingParameters[key]:0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

  private computeDisplayedRows(): void {
    this.firstRegisterShown = 1 + this.listBusStopService.currentPage * this.listBusStopService.rowsPerPage;
    this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listBusStopService.rowsPerPage - 1, this.busStopData.registers);
  }

  private requestRowsToParent(): void {
    this.busStopService.getList(
      this.listBusStopService.rowsPerPage, //Limit
      this.listBusStopService.currentPage*this.listBusStopService.rowsPerPage, //Skip
      this.activeFilters //FILTRE DE LS PROPIETARIS QUE ES MOSTREN A INICI
      ,{}//Conds a aplicar. Per defecte LIKE %%
      ,this.currentOrdering //ORDRE DELS PROPIETARIS QUE ES MOSTREN A INICI
      ,this.export
    ).subscribe(
      data => {
        if(!this.export){this.busStopData = data;this.computeDisplayedRows();}
        else{
          var csvData = this.convertToCSV(data.rows);
          var file = new Blob(["\ufeff",csvData], { type: 'text/csv;charset=utf-8' });
          saveAs(file, "export.csv");
        }
      },
      error => console.log(error)
    );
  }

  public requestPrevious(): void {
     this.listBusStopService.currentPage = Math.max(0, this.listBusStopService.currentPage - 1);
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public requestNext(): void {
     this.listBusStopService.currentPage = this.listBusStopService.currentPage + 1;
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public setRowPerPage(rowsPerPage: number) {
     this.listBusStopService.rowsPerPage = rowsPerPage;
     this.requestRowsToParent();
  }

  public busStopFilters: Array<any>
  public ordreCamps: Array<any>
  public tableFields: Array<any>

  constructor(public tokenStorage: TokenStorageService, public listBusStopService: ListService, public dialog:MatDialog, private busStopService: BusStopService, private router: Router, private route: ActivatedRoute) {
  this.userInfo = this.tokenStorage.getUser();}

  ngOnInit() {
    this.ordreCamps = ['id'];

    this.tableFields = [
      ['id', 'Id'],
      ['name', 'Name'],
      ['address', 'Address'],
      ['city', 'City'],
      ['cp', 'CP'],
      ['type', 'Type'],
      ['last_inspection', 'Last inspection' ]
  	];

    this.busStopFilters = [
    {
      inputs: []
    },
    {
      inputs: [
        {
          name: 'text',
          type: 'text',
          values: [
 {
                text: 'Id',//Text a mostrar label
                name: 'id',//Camp de la base de dades
                autocomplete: 'id',//Crida per obtenir els valors si autocomplete
                value: this.listBusStopService.getSearchValues('text')//valor a mostrar
              }
          ]
        }
      ]
    }
  ];

  this.orderingParameters = this.tableFields.reduce((acum, curr) => {
      acum[curr[0]] = 0;
      return acum;
    }, {});
    ['id'].map(item => this.currentOrdering[item] = this.orderingCycle[2]);
 
    const id = this.route.snapshot.paramMap.get('id');
    
    if (id) {
      this.computeActiveFilters({ id: id });
    } else {
      this.computeActiveFilters({});
    }

    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
      this.unsubscriber.next();
      this.unsubscriber.complete();
  }

  go(lloc, id){this.router.navigate([lloc, id]);}

}
	